// extracted by mini-css-extract-plugin
module.exports = {"root":"Cell_root__2OL8e","interactive":"Cell_interactive__364pM"};